import type { UserParametersModel, UserParamsMap } from "../type/user";

export const normalizeParameters = (
  parameters?: UserParametersModel[] | string
): UserParamsMap => {
  const result: UserParamsMap = {};

  if (!parameters) return result;

  const parsed: UserParametersModel[] =
    typeof parameters === "string" ? JSON.parse(parameters) : parameters;

  for (const p of parsed) {
    let value: boolean | string | number;

    switch (p.paramtype) {
      case "bool":
      case "boolean":
        value = p.value === true || p.value === "true";
        break;
      case "number":
        value = Number(p.value);
        break;
      default:
        value = p.value;
    }

    result[p.paramname] = {
      value,
      group: p.group ?? "",
      label: p.label ?? "",
      description: p.description ?? "",
      paramtype: p.paramtype,
    };
  }

  return result;
};